import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Svg} from '@modifi/ui'

const propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}
const defaultProps = {
  color: 'currentColor',
  width: 16,
  height: 16,
}

type ShipIconProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const ShipIcon: React.FC<ShipIconProps> = ({color, ...restProps}) => (
  <Svg viewBox="0 0 142 41" color={color} {...restProps}>
    <path d="M24 23.7036L34.9677 39.9999H107.772L117.333 23.7036H24Z" />
    <path d="M44.7406 18.7656H35.3579V4.93848H40.0482L42.4603 6.91288L44.7406 8.74958V18.7656Z" />
    <path d="M50.1729 11.8521H29.926V13.8274H50.1729V11.8521Z" />
    <path d="M48.1975 11.8521H32.395V23.7039H48.1975V11.8521Z" />
    <path d="M71.4075 15.8022H63.0125V23.7035H71.4075V15.8022Z" />
    <path d="M79.8024 15.8022H71.9011V23.7035H79.8024V15.8022Z" />
    <path d="M88.6914 15.8022H80.2964V23.7035H88.6914V15.8022Z" />
    <path d="M97.0865 15.8022H89.1853V23.7035H97.0865V15.8022Z" />
    <path d="M105.975 15.8022H98.074V23.7035H105.975V15.8022Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.8271 0V4.93827H37.3333V0H37.8271Z"
      fill="#15539F"
    />
    <line y1="40.5" x2="142" y2="40.5" stroke={color} />
  </Svg>
)

ShipIcon.propTypes = propTypes
ShipIcon.defaultProps = defaultProps

export default ShipIcon
